import { gql } from "@apollo/client"

export const EDUCATION_CPP_OFFERING_QUERY = gql`
  query EducationCppOffering {
    me {
      id
      educationCppOffering {
        id
      }
    }
  }
`

export const CPP_PURCHASE_UNAVAILABLE_MESSAGE =
  "Enrollment in the Certified Professional Program isn't available right now. Please call PGA Education at (866) 866-3382, option 6."

export const reportCppPurchaseUnavailable = error => {
  window.rg4js &&
    window.rg4js("send", { error, tags: ["education-cpp-purchase"] })
}
